function eachElements(elementOrElements, callback) {
  if (elementOrElements instanceof Node) {
    return [callback(elementOrElements)];
  }
  return Array.from(elementOrElements).map(callback);
}
export {
  eachElements
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
